<template>
  <div class="modal fade" id="modalReportAndSuggestion" role="dialog">
    <div class="modal-dialog modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h2 class="certa first-title text-center">
            <span v-if="typeModal === 1">Envio de Sugestão</span>
            <span v-if="typeModal === 2">Reportar problema</span>
          </h2>
        </div>

        <div class="modal-body">
          <form>
            <div class="form-group input-blue">
              <label>
                <span v-if="typeModal === 1">Informe sua sugestão.</span>
                <span v-if="typeModal === 2">Informe o seu problema.</span>
              </label>
              <textarea v-model="dataToSend.text" v-bind:placeholder="place" class="textarea"></textarea>
              <span v-if="errorModal.text" class="error-msg-modal">{{errorModal.text}}</span>
            </div>
          </form>
        </div>

        <div class="modal-footer offset-top-20">
          <button v-on:click="checkSend()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="nunito btn-yellow-save">
            <span v-if="!loadingChange">Salvar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="nunito close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {UTIL_SERVICE} from "../../../utils";
  import {SEND_SUGGESTION, SEND_BUG} from "../../../urlConfig";
  import {REQUEST_SERVICE} from "../../../requestConfig";
  import swal from "sweetalert";

  export default {
    name: "modal-report-and-suggestion",
    props: ['objRS'],
    watch: {
      objRS: function (val) {
        this.typeModal = val.type;

        if (val.type === 1)
          this.place = "Fique a vontade para nos contar sua sugestão ou alguma melhoria para o sistema.";

        if (val.type === 2)
          this.place = "Fique a vontade para nos contar qualquer problema que esteja acontecendo.";
      },
      emitValue : function(val){
        this.$emit('update:actionLeftMenu', val)
      }
    },
    data() {
      return {
        loadingChange: false,
        typeModal: '',
        place: '',
        emitValue: {
          value: '',
          random: ''
        },
        errorModal: {
          text: ''
        },
        dataToSend: {
          text: '',
          deviceModel: '',
          version: '',
          userId: '',
          deviceType: ''
        }
      }
    },
    methods: {
      closeModalAndReturn(valueToEmit) {
        this.emitValue = {value: valueToEmit, random: Math.floor(Math.random() * 500)};

        $('#modalReportAndSuggestion').modal('toggle');
        $('.modal-backdrop').remove();
      },
      sendReport() {
        REQUEST_SERVICE.post(SEND_BUG, this.dataToSend).then((response) => {
          UTIL_SERVICE.console("RESULT :", response.data);

          this.loadingChange = false;
          this.dataToSend.text = '';

          this.closeModalAndReturn({text: response.data, isSuccess: true, width: '350px'});
        }).catch(reason => {
          this.closeModal();
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      sendSuggestion() {
        REQUEST_SERVICE.post(SEND_SUGGESTION, this.dataToSend).then((response) => {
          UTIL_SERVICE.console("RESULT :", response.data);

          this.loadingChange = false;
          this.dataToSend.text = '';

          this.closeModalAndReturn({text: response.data, isSuccess: true, width: '350px'});
        }).catch(reason => {
          this.closeModal();
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      checkSend() {
        this.errorModal.text = "";

        if (this.dataToSend.text) {
          if (!this.loadingChange) {
            this.loadingChange = true;

            let browserInfo = UTIL_SERVICE.checkBrowser();
            try {
              this.dataToSend.userId = JSON.parse(window.localStorage.getItem('userInfo')).id;
              this.dataToSend.deviceModel = browserInfo.name;
              this.dataToSend.version = browserInfo.version;
              this.dataToSend.deviceType = "3";
            } catch (e) {}

            UTIL_SERVICE.console("DATA SEND:", this.dataToSend);

            if (this.typeModal === 1) {
              this.sendSuggestion();
            } else {
              this.dataToSend.subject = "99";
              this.sendReport();
            }
          }
        } else {
          this.errorModal.text = "Campo obrigatório."
        }
      },
      closeModal() {
        this.errorModal.text = '';

        $('#modalReportAndSuggestion').modal('toggle');
        $('.modal-backdrop').remove();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/views/modals/modalReportAndSuggestion.vue